module.exports = __webpack_public_path__ + "static/media/friday-che-big-mobile.47e67d13.png";